import {
  SET_JOURNEY_DATA,
  SET_PATCH_TEST_PASSED,
  SET_SEARCH_QUERY,
  SET_CATEGORY,
  CLEAR_SELECTED_FACETS,
  REMOVE_FACET,
  SELECT_FACET,
  SET_PREV_PATH_CONFIGS,
} from './journey-state.actions';

const initialState = {
  searchQuery: '',
  patchTestPassed: false,
  categoryId: '',
  selectedFacets: [],
  prevPathConfigs: [],
  progressBarItemConfigs: [],
};

export const journeyStateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_JOURNEY_DATA:
      return {
        ...payload,
      };
    case SET_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: payload,
        categoryId: initialState.categoryId, // BKM-1461
        prevPathConfigs: initialState.prevPathConfigs,
      };
    case SET_PATCH_TEST_PASSED:
      return {
        ...state,
        patchTestPassed: payload,
      };
    case SET_CATEGORY:
      return {
        ...state,
        categoryId: payload,
      };
    case CLEAR_SELECTED_FACETS:
      return {
        ...state,
        selectedFacets: initialState.selectedFacets,
      };
    case SELECT_FACET:
      return {
        ...state,
        selectedFacets: state.selectedFacets.concat(payload),
      };
    case REMOVE_FACET:
      return {
        ...state,
        selectedFacets: state.selectedFacets.filter(
          ({ group, value }) => group !== payload.group || value !== payload.value,
        ),
      };
    case SET_PREV_PATH_CONFIGS:
      return {
        ...state,
        prevPathConfigs: payload,
      };
    default:
      return state;
  }
};
